[
  {
    "title": "Algorithms & Data Structures",
    "issuer": "LeetCode & HackerRank",
    "date": "Ongoing",
    "description": "Solved 200+ DSA problems optimizing dynamic programming and graph algorithms.",
    "url": "https://leetcode.com"
  },
  {
    "title": "Open Source Contributions",
    "issuer": "GitHub",
    "date": "Ongoing",
    "description": "Maintains 17+ public GitHub repositories spanning full-stack, machine learning, and systems projects.",
    "url": "https://github.com/HelloVishnu04"
  },
  {
    "title": "2nd Place — Hack The Box TechTrix",
    "issuer": "Cybersecurity Competition",
    "date": "Recent",
    "description": "Secured 2nd place in the Hack The Box TechTrix Cybersecurity Competition.",
    "url": ""
  },
  {
    "title": "Top 5 Finalist (Pan-India)",
    "issuer": "Virtual Lab Hackathon",
    "date": "Recent",
    "description": "Recognized as a Top 5 Finalist in the Pan-India Virtual Lab Hackathon.",
    "url": ""
  },
  {
    "title": "Exploratory Data Analysis, Gold Certification (NSQF Level 5)",
    "issuer": "NASSCOM FutureSkills Prime, MeitY, Govt. of India",
    "date": "2026",
    "description": "Gold Certification (NSQF Level 5) in Exploratory Data Analysis.",
    "url": ""
  },
  {
    "title": "Oracle Cloud Infrastructure (OCI) Data Science Professional",
    "issuer": "Oracle",
    "date": "2025",
    "description": "Professional certification in Oracle Cloud Infrastructure (OCI) Data Science.",
    "url": ""
  },
  {
    "title": "SQL Certificate (Intermediate)",
    "issuer": "HackerRank",
    "date": "2024",
    "description": "Intermediate level SQL certification.",
    "url": ""
  }
]
